var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"10px 0 0 10px"}},[_c('a-pagination',{attrs:{"show-quick-jumper":"","defaultPageSize":_vm.defaultPageSize,"default-current":_vm.current,"total":_vm.total},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }